import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import * as _ from 'lodash';

import { UserService } from 'shared/user/user.service';
import { BrandService } from 'shared/brand/brand.service';

import { Config } from '../config/env.config';


@Injectable()
export class ProductsPageGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService,
    private brandService: BrandService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean {
    return new Observable(observer => {
      this.userService.getUser()
        .subscribe((user: any) => {
          const userId = user.id;
          const brandId = this.brandService.getBrand();
          const varName = `newPartAttributesAdvancedSearch.${userId}.${brandId}`;
          if (!localStorage.getItem(varName)) {
            localStorage.setItem(varName, 'true');
            observer.next(true);
          } else {
            observer.next(true);
          }
          observer.complete();
        });
    });
  }
}
